export default __webpack_public_path__ + "2cd8e4836927d934ff499a68bd51c152.png";